import { Component } from '@angular/core'

import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    template: ` <div appAutoSize style="border: 1px solid lightgray">
        <iframe
            width="100%"
            height="100%"
            src="https://app.powerbi.com/reportEmbed?reportId=19f15ee4-7a24-4465-b95d-97769f6ed4d0&appId=2e9c579c-dbfc-4ea9-bc96-8a0bc361b51b&autoAuth=true&ctid=27c00eb3-08d1-4630-a0be-e2ae3bb5337c"
            frameborder="0"
            allowFullScreen="true"
        ></iframe>
    </div>`,
    standalone: true,
    imports: [AutoSizeDirective],
})
export class EquipmentWarrantyComponent {}
